export const PRACTICE_ANALYTICS_VIDEO_URL = 'https://fast.wistia.com/embed/medias/ymxr76flgk';
export const PRACTICE_ANALYTICS_ONBOARDING_URL =
  'https://getweave.chilipiper.com/book/upsell?type=652829d5d593786d70b20303&back=true';
export const PRACTICE_ANALYTICS_PRICE = 199;
